import { createFileRoute } from '@tanstack/react-router'
import { ResellerSmtpPage } from '@/features/reseller/pages/smtp'

export const Route = createFileRoute('/_authenticated/reseller/smtp')({
  component: ResellerSmtpPage,
})
